<mat-form-field appearance="outline" class="search-field">
  <app-icon matPrefix class="icon" [icon]="iconName.SEARCH" />
  <input
    matInput
    [placeholder]="placeholder()"
    [value]="searchTerm()"
    (input)="onInputChange($event)"
  />
</mat-form-field>
